import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setTelemedicineBillingCodes } from 'src/store/modules/dashboard'

import { GET_TELEMEDICINE_BILLING_CODES } from 'src/constants'

export const fetchTelemedicineBillingCodes = () => async (dispatch) => {
  try {
    const items = await httpClient.request({
      method: 'get',
      url: {
        pathname: GET_TELEMEDICINE_BILLING_CODES
      }
    })

    dispatch(setTelemedicineBillingCodes(items))

    return items
  } catch (err) {
    catchError(err)
  }
}
